"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpLocaleSelector = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const locale_selector_html_1 = __importDefault(require("./locale-selector.html"));
let ItpLocaleSelector = class ItpLocaleSelector extends vue_property_decorator_1.Vue {
    data() {
        const locales = this.$app.i18n.getLocales();
        return {
            options: this.$app.i18n.getLocales().map(loc => ({
                value: loc.code,
                text: loc.name
            }))
        };
    }
    get localeCode() {
        return this.$app.i18n.locale;
    }
    set localeCode(value) {
        this.$app.i18n.setLocale(value);
    }
};
exports.ItpLocaleSelector = ItpLocaleSelector;
exports.ItpLocaleSelector = ItpLocaleSelector = __decorate([
    (0, vue_property_decorator_1.Component)({ template: locale_selector_html_1.default })
], ItpLocaleSelector);
//# sourceMappingURL=locale-selector.js.map